<template>
  <div>
    <TCModal v-if="showModal && selectedPackage === 0"></TCModal>
    <footer id="footer">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-4 col-sm-12">
            <div class="footer-about">
              <h2>Doni të dini më shumë rreth kompanisë Marimanga?</h2>
              <a href="tel:+383 44 662 663">
                <i class="fas fa-phone"></i>+383 44 662 663
              </a>
              <br>
              <a href="tel:0800 22 800">
                <i class="fas fa-phone"></i>0800 22 800 - pa pagesë
              </a>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 offset-md-3 col-sm-12">
            <div class="footer-social">
              <ul style="list-style:none;">
                <li>Na përcillni në rrjete sociale</li>
                <li>
                  <a href="https://www.facebook.com/marimanga.net/" target="_blank">
                    <i class="fa fa-facebook-official" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/marimangaks" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-12">
            <ul class="terms">
              <li>© {{ new Date().getFullYear() }} Marimanga, All Rights Reserved</li>
              <li>
                <a href @click="getShowModal('terms-conditions', $event)">Terms & Conditions</a>
              </li>
              <li>
                <router-link to="/privacy-policy" tag="a">Privacy Policy</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
import TCModal from "@/components/TCModal.vue";
import { mapGetters } from "vuex";

export default {
  name: "Footer",
  components: {
    TCModal
  },
  data() {
    return {
      frontEndUrl: process.env.VUE_APP_FRONT_END_BASE_URL
    }
  },
  methods: {
    getShowModal(type, e) {
      e.preventDefault();
      let pdfPath;
      if (type === "terms-conditions") {
        pdfPath = `${this.frontEndUrl}/pdf/default.pdf`;
      }
      window.open(pdfPath, "_blank");
    }
  },
  computed: {
    ...mapGetters({
      showModal: "billing/showModal",
      selectedPackage: "selected/selectedPackage"
    })
  }
};
</script>
